import type { Projects } from "@/types";
import ResetFilter from "./reset";
import SearchFilter from "./search";
import StateFilter from "./state";
import TagsFilter from "./tags";
import YearFilter from "./year";
import { useAppSelector } from "@/redux/store/hooks";

const Filter = ({ projects }: Projects): JSX.Element => {
  const { queryFilter } = useAppSelector((state) => state.projectFinder);

  const {
    showSearch,
    showTagsFilter,
    showStateFilter,
    showYearFilter,
    showResetFilter
  } = queryFilter;

  return (
    <>
      {showSearch ? <SearchFilter key="title" /> : null}
      {showTagsFilter ? <TagsFilter key="tags" projects={projects} /> : null}
      {showYearFilter ? <YearFilter key="year" projects={projects} /> : null}
      {showStateFilter ? <StateFilter key="state" /> : null}
      {showResetFilter ? <ResetFilter key="reset" /> : null}
    </>
  );
};

export default Filter;
